import { makeStyles } from "@material-ui/core";

import prisaIcon from "./prisa-icon.png";

const useStyles = makeStyles({
  img: {
    width: 28,
    height: 28,
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return <img src={prisaIcon} alt="PRISA" className={classes.img} />;
};

export default LogoIcon;
